import { getKbaQuestionnaire, submitKba } from '../api/checks'
import { ClientLoaderUser } from '../api_client_portal/client_user'
import type { Resolvers } from '../generated/server/resolvers'
import { mortgageLoader } from '../loaders/mortgage'

const KbaResolvers: Resolvers = {
  Query: {
    kbaQuestionnaire: async (_, { userId, useClientApi }) => {
      return await getKbaQuestionnaire(userId, useClientApi)
    },
  },
  Mutation: {
    submitKbaQuestionnaire: async (_, { userId, input, useClientApi }) => {
      if (!useClientApi) {
        mortgageLoader.clear({ filter_client_ids: [userId] })
      }
      const response = await submitKba(userId, input, useClientApi)
      if (useClientApi) {
        // The credit report is pulled during this wait if KBA passed, so the client-portal loader's copy of this client is stale.
        // Case queries resolve clients through it and would otherwise overwrite the fresh /me data in Apollo.
        ClientLoaderUser.clear(userId)
      }
      return response
    },
  },
}

export default KbaResolvers
